import { themeColors } from '../../JuvareTheme';
export const tabStyle = {
    maxWidth: '300px',
    minHeight: 'initial',
    maxHeight: '40px',
    padding: '3px 8px',
    alignSelf: 'center',
    color: themeColors.text.link,
};
